import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { ArrayUnique, IsArray, IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID, Min, ValidateNested } from 'class-validator';
import { MenuSyncConfigExposeGroup } from '../interface';
import { ReadMenuSyncOptionsDto } from './ReadMenuSyncOptionsDto';
import { ReadWhiteListPropsDto } from './ReadWhiteListPropsDto';
export class ReadMenuSyncConfigDto {
}
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true, example: ['1', '2', '3'] }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsArray({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsString({ each: true, groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Array)
], ReadMenuSyncConfigDto.prototype, "categoryUuids", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    Expose({ groups: [MenuSyncConfigExposeGroup.READ] }),
    IsString({ groups: [MenuSyncConfigExposeGroup.READ] }),
    IsNotEmpty({ each: true, groups: [MenuSyncConfigExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadMenuSyncConfigDto.prototype, "merchantId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: '77s1gcn7-15bf-4aeg-1331-4eafbbd12921' }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsArray({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsString({ each: true, groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsNotEmpty({ each: true, always: true }),
    ArrayUnique({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Array)
], ReadMenuSyncConfigDto.prototype, "storeIds", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'c794792f-b101-42e0-8f06-74c6644ff951' }),
    Expose({ groups: [MenuSyncConfigExposeGroup.READ] }),
    IsUUID('4'),
    __metadata("design:type", String)
], ReadMenuSyncConfigDto.prototype, "uuid", void 0);
__decorate([
    ApiProperty({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncCategoriesEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncStockAvailabilityEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 1 }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsNumber({ maxDecimalPlaces: 0 }, { groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    Min(0, { groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Number)
], ReadMenuSyncConfigDto.prototype, "outOfStockQuantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncLocationAvailabilityEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncPriceEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncMenuEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isAutoSyncModifiersEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    IsBoolean({ groups: [MenuSyncConfigExposeGroup.PATCH, MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.UPDATE] }),
    __metadata("design:type", Boolean)
], ReadMenuSyncConfigDto.prototype, "isStoreItemGroupVariationsEnabled", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadMenuSyncOptionsDto),
    __metadata("design:type", ReadMenuSyncOptionsDto)
], ReadMenuSyncConfigDto.prototype, "options", void 0);
__decorate([
    Expose({ groups: [MenuSyncConfigExposeGroup.CREATE, MenuSyncConfigExposeGroup.READ, MenuSyncConfigExposeGroup.UPDATE, MenuSyncConfigExposeGroup.PATCH] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWhiteListPropsDto),
    __metadata("design:type", ReadWhiteListPropsDto)
], ReadMenuSyncConfigDto.prototype, "whiteListProps", void 0);
//# sourceMappingURL=ReadMenuSyncConfigDto.js.map